import { defineStore } from 'pinia';

export const usePointsStore = defineStore('points', {
    state: () => ({
        loading: false,
        reward: {},
        user: {},
        addRewardUser: {},
        programs: [],
        rewards: {
            users: [],
        },
        saveProgramBtnAction: false,
        showProgramModal: false,
        showEditProgramModal: false,
        showProgramUserOptionsModal: false,
        filteredUserPoints: [],
    }),
    actions: {
        async getRewards(disableCache = false) {
            this.loading = true;
            ApiService.apiCall('/rewards?disable_cache=' + disableCache, 'get')
                .then((response) => {
                    this.rewards = response.data.rewards;
                    this.programs = response.data.programs;
                    setTimeout(() => {
                        this.loading = false;
                    }, 500);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        editProgram(reward, user) {
            this.reward = reward;
            this.user = user;
            this.showEditProgramModal = true;
        },
        deleteProgram(reward) {
            ApiService.apiCall('/rewards/' + reward.manual_reward_id, 'delete')
                .then(() => {
                    this.getRewards();
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        setProgramModal(data) {
            this.showProgramModal = data;
        },
        setEditProgramModal(data) {
            this.showEditProgramModal = data;
        },
        showProgramModalAction(data) {
            this.addRewardUser = data;
            this.showProgramModal = true;
        },
        setShowProgramModal(val) {
            this.showProgramUserOptionsModal = val;
        },
        editProgramOptions(program, user) {
            this.reward = program;
            this.user = user;
            this.showProgramUserOptionsModal = true;
        },
        setRewardsOrigin() {
            ApiService.apiCall(
                '/program-user/' + this.reward.program_user.id + '/options',
                'put',
                this.reward.program_user
            )
                .then(() => {
                    this.getRewards();
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        filterDataByProgramId(programId) {
            // console.log(this.rewards.users);
            // console.log(programId);
            const filteredUsersPoints = this.rewards.users.reduce(
                (result, user) => {
                    const matchingPoints = user.programs.find(
                        (program) => program.id === programId
                    );
                    result.push({
                        userName: user.name,
                        userId: user.id,
                        points: matchingPoints ? matchingPoints.points : 0,
                    });
                    return result;
                },
                []
            );
            return filteredUsersPoints;
        },
        filterUserPoints(transferPartnersArray) {
            // param transferPartnersArray = transfer partners for specific program
            // returns users' points for each TP in transferPartnersArray
            this.filteredUserPoints = transferPartnersArray
                .map((partner) => {
                    const usersWithProgram = this.rewards.users
                        .filter((user) =>
                            user.programs.some(
                                (program) =>
                                    program.id === partner.source_program_id
                            )
                        )
                        .map((user) => ({
                            userName: user.name,
                            points: user.programs.find(
                                (program) =>
                                    program.id === partner.source_program_id
                            )?.points,
                        }));

                    if (usersWithProgram.length) {
                        const bonusExpiration = partner.bonus_expiration
                            ? partner.bonus_expiration
                            : null;

                        return {
                            programName: partner.source_program_name,
                            image: partner.source_program.image,
                            transferRateFrom: Number(
                                partner.transfer_rate_from
                            ),
                            transferRateTo: Number(partner.transfer_rate_to),
                            transferTime: partner.transfer_time,
                            transferInstructions: partner.transfer_instructions,
                            bonusExpiration: bonusExpiration,
                            bonusRateFrom: Number(partner.bonus_rate_from),
                            bonusRateTo: Number(partner.bonus_rate_to),
                            points: usersWithProgram,
                        };
                    }

                    return null;
                })
                .filter((filteredPoint) => filteredPoint !== null);
        },
    },
});
